import {Component, Injector} from '@angular/core';
import Swal from "sweetalert2";
import {ActivatedRoute, Router} from "@angular/router";
import {BaseComponent} from "../base/base.component";
import {UserService} from "../../services/user/user.service";
import {AthleteService} from "../../services/athlete/athlete.service";
import {CompanyDocumentService} from "../../services/companyDocument/document.service";
import {PaymentService} from "../../services/payment/payment.service";

@Component({
    selector: 'app-thankyou',
    templateUrl: './thankyou.component.html',
    styleUrls: ['./thankyou.component.scss']
})
export class ThankyouComponent extends BaseComponent {

  success: boolean = false;
  loading: boolean = true;

    constructor(public userService: UserService, public route: ActivatedRoute, public serviceInjector: Injector, public paymentService: PaymentService) {
        super(serviceInjector)

        this.success = this.route.snapshot.queryParamMap.get('esito') !== 'KO';
    }

  ngAfterViewInit() {
      // Simulate short processing/loading state so the user understands
      // that the payment outcome is being finalised.
      setTimeout(() => {
        this.loading = false;
      }, 1500);
  }

}
